import { TourDefinition } from "../tourTypes";

// Per-screen mini-tours, launched on demand from each screen's PageHero "?" button
// (TourHelpButton) and also listed in the "Nasıl kullanırım?" launcher — which
// navigates to each tour's `route` before starting so the anchors exist. Steps
// whose anchor is absent (empty state / conditional UI) are auto-skipped.

const learningPathTour: TourDefinition = {
  id: "learning-path",
  titleKey: "learning_path",
  descriptionKey: "tour_lp_desc",
  iconName: "path",
  route: "/learning-path",
  steps: [
    {
      id: "filter",
      anchorId: "lp-coterie-select",
      titleKey: "tour_lp_filter_title",
      bodyKey: "tour_lp_filter_body",
      placement: "bottom",
    },
    {
      id: "mastery",
      anchorId: "lp-mastery-filter",
      titleKey: "tour_lp_mastery_title",
      bodyKey: "tour_lp_mastery_body",
      placement: "bottom",
    },
    {
      id: "outcome",
      anchorId: "lp-outcome-card",
      titleKey: "tour_lp_outcome_title",
      bodyKey: "tour_lp_outcome_body",
      placement: "auto",
    },
  ],
};

const reportsTour: TourDefinition = {
  id: "reports",
  titleKey: "reports",
  descriptionKey: "tour_rep_desc",
  iconName: "chartBar",
  route: "/reports",
  steps: [
    {
      id: "filter",
      anchorId: "rep-coterie-select",
      titleKey: "tour_rep_filter_title",
      bodyKey: "tour_rep_filter_body",
      placement: "bottom",
    },
    {
      id: "time",
      anchorId: "rep-time-filter",
      titleKey: "tour_rep_time_title",
      bodyKey: "tour_rep_time_body",
      placement: "bottom",
    },
    {
      id: "views",
      anchorId: "rep-view-tabs",
      titleKey: "tour_rep_views_title",
      bodyKey: "tour_rep_views_body",
      placement: "bottom",
    },
    {
      id: "graph",
      anchorId: "rep-graph",
      titleKey: "tour_rep_graph_title",
      bodyKey: "tour_rep_graph_body",
      placement: "top",
    },
  ],
};

const marketTour: TourDefinition = {
  id: "market",
  titleKey: "market",
  descriptionKey: "tour_mk_desc",
  iconName: "storefront",
  route: "/market",
  steps: [
    {
      id: "types",
      anchorId: "mk-type-selector",
      titleKey: "tour_mk_types_title",
      bodyKey: "tour_mk_types_body",
      placement: "auto",
    },
    {
      id: "items",
      anchorId: "mk-items-panel",
      titleKey: "tour_mk_items_title",
      bodyKey: "tour_mk_items_body",
      placement: "auto",
    },
    {
      id: "preview",
      anchorId: "mk-mascot-preview",
      titleKey: "tour_mk_preview_title",
      bodyKey: "tour_mk_preview_body",
      placement: "auto",
    },
    {
      id: "purchase",
      anchorId: "mk-purchase",
      titleKey: "tour_mk_purchase_title",
      bodyKey: "tour_mk_purchase_body",
      placement: "auto",
    },
  ],
};

const practiseTour: TourDefinition = {
  id: "practise",
  titleKey: "practise_now",
  descriptionKey: "tour_pr_desc",
  iconName: "target",
  route: "/practise",
  steps: [
    {
      id: "filter",
      anchorId: "pr-lesson-select",
      titleKey: "tour_pr_filter_title",
      bodyKey: "tour_pr_filter_body",
      placement: "bottom",
    },
    {
      id: "tabs",
      anchorId: "pr-tabs",
      titleKey: "tour_pr_tabs_title",
      bodyKey: "tour_pr_tabs_body",
      placement: "bottom",
    },
  ],
};

const plansTour: TourDefinition = {
  id: "plans",
  titleKey: "plans",
  descriptionKey: "tour_pln_desc",
  iconName: "calendar",
  route: "/framework-annual-plans",
  steps: [
    {
      id: "filter",
      anchorId: "pln-lesson-select",
      titleKey: "tour_pln_filter_title",
      bodyKey: "tour_pln_filter_body",
      placement: "bottom",
    },
    {
      id: "weeks",
      anchorId: "pln-weeks",
      titleKey: "tour_pln_weeks_title",
      bodyKey: "tour_pln_weeks_body",
      placement: "auto",
    },
  ],
};

const profileTour: TourDefinition = {
  id: "profile",
  titleKey: "my_profile",
  descriptionKey: "tour_prof_desc",
  iconName: "user",
  route: "/profile",
  steps: [
    {
      id: "identity",
      anchorId: "prof-identity",
      titleKey: "tour_prof_identity_title",
      bodyKey: "tour_prof_identity_body",
      placement: "bottom",
    },
    {
      id: "stats",
      anchorId: "prof-stats",
      titleKey: "tour_prof_stats_title",
      bodyKey: "tour_prof_stats_body",
      placement: "bottom",
    },
    {
      id: "showcase",
      anchorId: "prof-showcase",
      titleKey: "tour_prof_showcase_title",
      bodyKey: "tour_prof_showcase_body",
      placement: "auto",
    },
    {
      id: "mascot",
      anchorId: "prof-mascot",
      titleKey: "tour_prof_mascot_title",
      bodyKey: "tour_prof_mascot_body",
      placement: "auto",
    },
    {
      id: "week",
      anchorId: "prof-week",
      titleKey: "tour_prof_week_title",
      bodyKey: "tour_prof_week_body",
      placement: "auto",
    },
  ],
};

const homeworksTour: TourDefinition = {
  id: "homeworks",
  titleKey: "homeworks",
  descriptionKey: "tour_hw_desc",
  iconName: "listChecks",
  route: "/homeworks",
  steps: [
    {
      id: "tabs",
      anchorId: "hw-tabs",
      titleKey: "tour_hw_tabs_title",
      bodyKey: "tour_hw_tabs_body",
      placement: "bottom",
    },
    {
      id: "list",
      anchorId: "hw-list",
      titleKey: "tour_hw_list_title",
      bodyKey: "tour_hw_list_body",
      placement: "auto",
    },
  ],
};

const contestsTour: TourDefinition = {
  id: "contests",
  titleKey: "contest",
  descriptionKey: "tour_con_desc",
  iconName: "trophy",
  route: "/contests",
  steps: [
    {
      id: "cards",
      anchorId: "con-cards",
      titleKey: "tour_con_cards_title",
      bodyKey: "tour_con_cards_body",
      placement: "auto",
    },
    {
      id: "boards",
      anchorId: "con-boards",
      titleKey: "tour_con_boards_title",
      bodyKey: "tour_con_boards_body",
      placement: "top",
    },
  ],
};

const announcementsTour: TourDefinition = {
  id: "announcements",
  titleKey: "announcements",
  descriptionKey: "tour_ann_desc",
  iconName: "megaphone",
  route: "/announcements",
  steps: [
    {
      id: "list",
      anchorId: "ann-list",
      titleKey: "tour_ann_list_title",
      bodyKey: "tour_ann_list_body",
      placement: "auto",
    },
    {
      id: "calendar",
      anchorId: "ann-calendar",
      titleKey: "tour_ann_cal_title",
      bodyKey: "tour_ann_cal_body",
      placement: "auto",
    },
  ],
};

export const screenTours: TourDefinition[] = [
  learningPathTour,
  reportsTour,
  marketTour,
  practiseTour,
  plansTour,
  profileTour,
  homeworksTour,
  contestsTour,
  announcementsTour,
];
